package com.milta.core.localization.translations.fr

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Équipe",
    statusActive = "Actif",
    errorGeneric = "Une erreur s'est produite. Veuillez réessayer.",
    monthNames = listOf("janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"),
    enterpriseSectionLabel = "Chauffeurs de l'équipe",
    enterpriseEmptyHint = "Aucun chauffeur dans votre équipe pour l'instant.",
    noEnterpriseFound = "Aucune entreprise associée à votre compte.",
    columnHeaderDriver = "Chauffeur",
    columnHeaderStatus = "Statut",
    columnHeaderActions = "Actions",
    addDriverSectionTitle = "Ajouter un chauffeur",
    addDriverCodePlaceholder = "Code Milta — ex : MTA-28371",
    addDriverButton = "Ajouter ce chauffeur",
    addDriverErrorInvalidCode = "Veuillez entrer un code valide.",
    addDriverErrorNotFound = "Code invalide ou déjà utilisé.",
    addDriverErrorAlreadyMember = "Ce chauffeur fait déjà partie de votre équipe.",
    addDriverErrorLinkedAccountIsEnterprise = "Ce compte est une entreprise et ne peut pas être ajouté comme chauffeur.",
    addDriverErrorLimitReached = "Limite atteinte : une Entreprise ne peut pas compter plus de 10 membres, vous compris. Retirez un chauffeur pour en ajouter un autre.",
    addDriverErrorEnterpriseSubscriptionInactive = "Votre abonnement Entreprise a expiré : renouvelez-le pour ajouter un chauffeur.",
    driverDetailTitle = "Détail du chauffeur",
    driverDetailPhoneLabel = "Téléphone",
    removeDriverButton = "Retirer",
    removeDriverDialogTitle = "Retirer ce chauffeur ?",
    removeDriverDialogMessagePrefix = "Vous êtes sur le point de retirer",
    removeDriverDialogMessageSuffix = "de votre équipe. Son compte Milta restera actif.",
    removeDriverErrorNotFound = "Chauffeur introuvable.",
    removeDriverErrorOnActiveDelivery = "Ce chauffeur est actuellement en cours de livraison et ne peut pas être retiré.",
    removeDriverErrorLastOwner = "Vous êtes le seul gestionnaire de cette entreprise. Ajoutez un autre compte Entreprise avant de vous retirer de l'équipe.",
)
